import genReducer from "../core/reducer";
import types from "./types";
import initialState from "./initialState";

export const TAGS_MODEL = "tags";

export default genReducer(types, initialState);
